export default __webpack_public_path__ + "6b30035.png";